<div class="creation-wrapper">
  <div class="creation-container">
    <div class="header">
      <div class="stepper">
        <ng-container *ngFor="let tab of tabs; let i = index">
          <!-- [ngClass]="{
            disabled:
              tab === 'View Purple File Output' ||
              tab === 'View Output Summary'
          }" -->
          <h3
            [ngClass]="{
              disabled: checkStatus(i) ? isEmptyObject(baseDetails) : false
            }"
            style="margin: 0px"
            class="medium-header-montserrat single-tab"
          >
            <img
              *ngIf="showCompleted(i)"
              src="../../assets/IMP PVP Tool Icons/completed.svg"
              alt=""
            />
            <span
              class="tab-number"
              [ngClass]="{
                active_tab: tab == activeTab,
                not_active: tab != activeTab
              }"
              *ngIf="!showCompleted(i)"
            >
              {{ i + 1 }}
            </span>
            <span
              [ngClass]="{
                active_text: tab == activeTab
              }"
              class="medium-header-montserrat"
              style="cursor: pointer"
              (click)="moveLevel(tab)"
            >
              {{ tab }}
            </span>
          </h3>
          <mat-icon *ngIf="i !== tabs.length - 1"> chevron_right </mat-icon>
        </ng-container>
      </div>
    </div>

    <div
      class="child-comps-wrap common-width"
      [ngStyle]="{
        'max-width':
          activeTab == tabs[1] || activeTab == tabs[2] ? '1766px' : '1160px'
      }"
    >
      <!-- <div class="back-wrap">
        <mat-icon style="font-size: 30px; cursor: pointer" (click)="goBack()">
          arrow_back
        </mat-icon>
      </div> -->
      <div class="child-comps">
        <app-base-scenario
          [moveLevel]="moveLevel.bind(this)"
          *ngIf="activeTab == tabs[0]"
        ></app-base-scenario>
        <app-scenario-builder
          *ngIf="activeTab == tabs[1]"
        ></app-scenario-builder>
        <app-output-summary *ngIf="activeTab == tabs[2]"></app-output-summary>
      </div>
    </div>
  </div>
</div>

<!-- Copyright 2022 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at https://angular.io/license -->
